import { useMutation } from '@tanstack/react-query';
import { postVerificationQuestionaries } from '../requests';
import type { SubmitVerificationQuestionariesRequestDto } from '../types';

const useVerificationQuestionariesSubmit = () => {
  const mutation = useMutation({
    mutationFn: (data: SubmitVerificationQuestionariesRequestDto) => {
      return postVerificationQuestionaries(data);
    },
  });

  return {
    submitVerificationQuestionaries: mutation.mutateAsync,
    submitResult: mutation.data,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    resetQuestionariesSubmit: mutation.reset,
  };
};

export { useVerificationQuestionariesSubmit };
